import axios from "axios";

import Navbar from './Navbar'
import Topbar from './Topbar'

import {useState, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {APIURL} from './config'
import Loading from './Loading'

function Ideias() {

    const [results, setResults] = useState()
    const [origem, setOrigem] = useState()
    const [classificacao, setClassificacao] = useState()
    const [tipo, setTipo] = useState()
    const [listaclassificacao, setListaclassificacao] = useState()
    const [listatipo, setListatipo] = useState()
    const [status, setStatus] = useState()
    const [texto, setTexto] = useState()
    const [mydisplay, setMydisplay] = useState('none') 
    const [btnText, setBtnText] = useState('Filtrar');

    const navigate = useNavigate()

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
        listresume( sessionStorage.getItem("tokeninovacao"))
    }, [])

    const listresume= async (mytoken) => {
        
        try {
            const res = await axios.post(`${APIURL}/Inovation/Ideas`, {TOKEN : mytoken});
            if (res.data) {
                setResults(res.data);
                //pega as classificações existentes
                const res2 = await axios.post(`${APIURL}/Process/ListProcessClassificationForService`, {TOKEN : mytoken, Id_Service: "5716", Id_Process_Category:"10351"});
                
                if (res2.data[0].id) {
                    setListaclassificacao(res2.data);
                    
                } else {
                    alert("Erro na seleção de classificação")
                }
            }
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    const doFilter= async (e) => {
        e.preventDefault()
        setBtnText('Filtrando...'); // muda o texto ao iniciar
        try {
            
            if (status != "Aprovado" && status != "Reprovado") {
                const res = await axios.post(`${APIURL}/Inovation/Ideas`, {TOKEN : sessionStorage.getItem("tokeninovacao"), Status: status, Search: texto, Id_Classification : classificacao, Id_Requester: origem });
                if (res.data) {
                    setResults(res.data);
                    //setMydisplay('none')
                } else {
                    alert("nada encocntrado")
                }
            } else {
                let myaprov
                if (status == "Aprovado") {
                    myaprov = true
                } else {
                    //reprovado
                    myaprov = false
                }
                const res2= await axios.post(`${APIURL}/Inovation/Ideas`, {TOKEN : sessionStorage.getItem("tokeninovacao"), OnlyApproved:myaprov, ListAprovedInnovations: true });
                if (res2.data) {
                    setResults(res2.data);
                    //setMydisplay('none')
                } else {
                    alert("nada encontrado")
                }
            }
            setBtnText('Filtrar'); 
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    const listartipos= async (classificacao) => {
        setClassificacao(classificacao)
        if ( classificacao != "a Classificar" ) {
            
            try {
                
                //pega os tipos existentes
                const res3 = await axios.post(`${APIURL}/Process/ListProcessClassificationTypesForService`, {TOKEN : sessionStorage.getItem("tokeninovacao"), Id_Service: "5716", Id_Process_Category: "10351", Id_Classification: classificacao});
                if (res3.data[0].id) {
                    setListatipo(res3.data);
                } else {
                    alert("Erro na listagem de tipos!")
                }
            } catch (err) {
                alert("Ocorreu um erro na chamada.");
            }
        } else {
            setListatipo()
        }
        
    }

    function mostrafiltro() {
        if (mydisplay == 'block') {
            setMydisplay('none')
        }else {
            setMydisplay('block')
        }
    }

    function retornadata(data) {
        const myday = new Date(data).getDate()
        const mymonth = new Date(data).getMonth()+1
        const myyear = new Date(data).getFullYear()
        const mydate = myday + '/' + mymonth + '/' + myyear
        return mydate
    }

    return (
        <div>
            <Topbar />
            {results ?
            
                <div className="container py-4 px-2 px-md-5">
                    <div className="d-flex justify-content-between align-items-center ">
                        <div className="h4 mb-0">Ideias</div>
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <div>
                                <button onClick={()=> mostrafiltro()} className="btn btn-success " ><i className="bi bi-filter fs-6 "></i></button>
                            </div>
                            <div className="" >
                                <Link to="/novaideia"><button className="btn btn-xs  btn-success" ><i className="bi bi-plus fs-6 "></i> Nova Ideia </button></Link>
                            </div>
                        </div>
                    </div>
                        

                    <div className=" bg-white p-3 mt-4 shadow-sm" style={{display: mydisplay}}>
                            <p  className="mb-2" >Selecione o filtro:</p>
                            <form onSubmit={(e)=> doFilter(e)} role="form" >
                            <div className="row g-3 mb-3">
                                {sessionStorage.getItem("tipousuario") != 4 &&
                                    <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Origem: </label> 
                                        <select  onChange={(e)=> setOrigem(e.target.value)} className="form-control">
                                            <option value="">Todas</option>
                                            <option value={sessionStorage.getItem("codigousuario")}>Só as minhas</option>
                                        </select>
                                    </div>
                                }
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Status: </label> 
                                    <select  onChange={(e)=> setStatus(e.target.value)} className="form-control">
                                        <option value="">Todas</option>
                                        <option value="em Aberto">em Aberto</option>
                                        <option value="em Andamento">em Andamento</option>
                                        <option value="Cancelado">Canceladas</option>
                                        <option value="Aprovado">Aprovadas</option>
                                        <option value="Reprovado">Reprovadas</option>
                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}>
                                    <label >Classificação: </label> 
                                    <select  onChange={(e)=> listartipos(e.target.value)} className="form-control">
                                        <option value="a Classificar">Todas</option>
                                        {listaclassificacao ?
                                            listaclassificacao.map((item, i) => {
                                                return(
                                                    <option key={i} value={item.id}>{item.value}</option>
                                                )
                                            })
                                        :
                                            <Loading />
                                        }
                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}>
                                    <label >Tipo: </label> 
                                    <select  onChange={(e)=> setTipo(e.target.value)} className="form-control">
                                        {classificacao &&
                                            <option value="">Selecione...</option>
                                        }
                                        {listatipo ?
                                            listatipo.map((item, i) => {
                                                return(
                                                    <option key={i} value={item.id}>{item.value}</option>
                                                )
                                            })
                                        :
                                            <Loading />
                                        }
                                    </select>
                                </div>
                                <div className="form-group col-12 col-md-2" style={{marginRight:20}}><label>Texto: </label> 
                                    <input type="text" className="form-control" required="" onChange={(e)=> setTexto(e.target.value)} />
            
                                </div>
                            </div> 
                                
                            <button id="btnFiltro" className="form-group btn btn-sm btn-success pull-left mt-3" type="submit"><strong>{btnText}</strong></button>
                            </form>

                    </div>
                        
                        
                    <table className="table table-striped mt-4">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">Título</th>
                            <th scope="col" className="d-none d-md-table-cell">Fase</th>
                            <th scope="col" className="d-none d-md-table-cell">Status</th>
                            <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                        {results.map((item, i) => {
                            return(
                                
                                <tr key={item.ID} >
                                    
                                    {/* <h5>Número: {item.NUMERO} - ID: {item.ID} - ID: {item.SOLICITANTE}</h5> */}
                                    <td>{item.NUMERO} - {item.ID}</td>
                                    <td className="fw-bold">{item.TITULO}</td>
                                    <td className="d-none d-md-table-cell">{item.FASE}</td>
                                    <td className="d-none d-md-table-cell">{item.STATUS}</td>
                                    
                    
                                    {/* <h5>Criado em: {retornadata(item.DATA_ABERTURA)} - Data Limite: {retornadata(item.DATA_LIMITE)}</h5> */}

                                    <td><Link to="/ideiaunica" state={{ideia_id: item.ID}}><i className="bi bi-chevron-right fs-6 "></i></Link></td>
                                    
                                    
                                </tr>
                                
                            )
                        })}
                        </tbody>
                    </table>

                    <div class="container mt-4">
  
                        <ul class="nav nav-tabs" id="meuTab" role="tablist">
                            <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="aba1-tab" data-bs-toggle="tab" href="#aba1" role="tab" aria-controls="aba1" aria-selected="true">
                                Aba 1
                            </a>
                            </li>
                            <li class="nav-item" role="presentation">
                            <a class="nav-link" id="aba2-tab" data-bs-toggle="tab" href="#aba2" role="tab" aria-controls="aba2" aria-selected="false">
                                Aba 2
                            </a>
                            </li>
                            <li class="nav-item" role="presentation">
                            <a class="nav-link" id="aba3-tab" data-bs-toggle="tab" href="#aba3" role="tab" aria-controls="aba3" aria-selected="false">
                                Aba 3
                            </a>
                            </li>
                        </ul>

                        
                        <div class="tab-content mt-3" id="meuTabConteudo">
                            <div class="tab-pane fade show active" id="aba1" role="tabpanel" aria-labelledby="aba1-tab">
                            <p>Conteúdo da Aba 1.</p>
                            </div>
                            <div class="tab-pane fade" id="aba2" role="tabpanel" aria-labelledby="aba2-tab">
                            <p>Conteúdo da Aba 2.</p>
                            </div>
                            <div class="tab-pane fade" id="aba3" role="tabpanel" aria-labelledby="aba3-tab">
                            <p>Conteúdo da Aba 3.</p>
                            </div>
                        </div>
                    </div>
                </div>

            :
                <Loading />
            }
        </div>
      );
    }
    
    export default Ideias;
